import { getDocs } from 'firebase/firestore';
import { collection } from 'firebase/firestore';
import { db } from './config';
import { createPublication } from './publicationService';

/**
 * Seed publications if the collection is empty
 */
export const seedPublications = async () => {
    try {
        // Check if publications already exist
        const publicationsCollection = collection(db, 'publications');
        const snapshot = await getDocs(publicationsCollection);

        if (snapshot.empty) {
            console.log('Seeding publications collection...');

            // Define initial publications
            const initialPublications = [
                {
                    title: 'A Novel Unified Lightweight Temporal-Spatial Transformer Approach for Intrusion Detection in Drone Networks',
                    authors: ['Tarun Kumar Biswas'],
                    year: '2026',
                    journal: 'Scientific Reports (Nature)',
                    conference: '',
                    location: '',
                    doi: '10.1038/s41598-026-45063-6',
                    abstract: 'A unified lightweight temporal-spatial transformer architecture for detecting intrusions in drone (UAV) networks, jointly modeling temporal and spatial traffic patterns to deliver accurate, resource-efficient intrusion detection.',
                    keywords: ['Intrusion Detection', 'Transformer', 'Drone Networks', 'UAV Security', 'Deep Learning'],
                    link: 'https://www.nature.com/articles/s41598-026-45063-6',
                    pdfUrl: '',
                    coverImage: '',
                    featured: true,
                    order: 0,
                },
            ];

            // Add each publication
            for (const publication of initialPublications) {
                await createPublication(publication);
            }

            console.log('Publications seeded successfully');
        } else {
            console.log('Publications collection already has data, skipping seed');
        }
    } catch (error) {
        console.error('Error seeding publications:', error);
    }
};

export default seedPublications;
